import React, { useState, useEffect } from 'react'
import BackgroundImage from '../../../assets/early/images/BackgroundImage.png'
import Header from './Header'
import { useTranslation } from 'react-i18next'
import InitSettings from './InitSettings'
import { getById } from '../../../server/server'
import { useQuery } from '../../../utils/util'

function StudentsSettingsScreen() {
    const query = useQuery()
    const classId = query.get('id')
    const [currentClass, setCurrentClass] = useState({})
    const [state, setState] = useState('init')
    const { t } = useTranslation()

    useEffect(() => {
        getClassInfo()
    }, [])

    const getClassInfo = async () => {
        const resp = await getById({ collection: 'class', id: classId })
        if (resp.status == 200) {
            setCurrentClass(resp.data)
        }
    }

    const openChangeAvatars = () => setState('changeAvatar')
    const goBackToInit = () => setState('init')
    return (
        <div className="w-full min-h-screen bg-cover bg-center bg-no-repeat pb-[15px]" style={{ backgroundImage: `url(${BackgroundImage})` }}>
            <Header text={t('Settings')} />
            {state == 'init' && <InitSettings openChangeAvatars={openChangeAvatars} />}
        </div>
    )
}

export default StudentsSettingsScreen
